import { baseRequest } from '.'
import _get from 'lodash/get'

export const getPaymentPlan = async eventId => {
  const res = await baseRequest.get(`event/${eventId}/payment-plan`)
  return _get(res, 'data.data.attributes')
}

export const createPaymentPlan = async (eventId, paymentPlanData) => {
  const res = await baseRequest.post(`event/${eventId}/payment-plan`, paymentPlanData)
  return _get(res, 'data.data.attributes')
}

export const updatePaymentPlan = async (eventId, paymentPlanData) => {
  const res = await baseRequest.put(`event/${eventId}/payment-plan`, paymentPlanData)
  return _get(res, 'data.data.attributes')
}
